export enum OptionalPaymentMethods {
  VENMO = 'venmo',
  PAYLATER = 'payLater',
  APPLEPAY = 'applePay',
  GOOGLEPAY = 'googlePay'
}

export enum SettingsTabName {
  CHECKOUT = 'checkout',
  STACKED_BUTTONS = 'stackedButtons',
  SINGLE_BUTTON = 'singleButton',
  CART_BUTTONS = 'cartButton'
}

export enum ButtonLayout {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}

export enum ButtonShape {
  Rect = 'rect',
  Pill = 'pill'
}

export enum ButtonSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

export enum ButtonColorType {
  Gold = 'gold',
  Black = 'black',
  White = 'white',
  Blue = 'blue',
  Silver = 'silver',
  Custom = 'custom'
}

export enum SecondButtonType {
  PayPalRecommended = 'paypalRecommended',
  PayLater = 'payLater',
  Venmo = 'venmo',
  None = 'none'
}

export enum ButtonTextType {
  Checkout = 'checkout',
  Proceed = 'proceed',
  Pay = 'pay',
  Custom = 'custom'
}

export enum SettingsTabIdx {
  CHECKOUT = 0,
  STACKED_BUTTONS = 1,
  SINGLE_BUTTON = 2,
  CART_BUTTONS = 3
}

export enum Stacked3ButtonPaymentOption {
  PayPal = 'paypal',
  Venmo = 'venmo',
  PayLater = 'paylater',
  Checkout = 'checkout'
}
